import { Injectable } from '@angular/core';
import {
  Router, Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot
} from '@angular/router';
import { NEVER, Observable, of } from 'rxjs';
import { Chain } from '../interfaces/chain';
import { switchMap } from 'rxjs/operators';
import { UserRoles } from '../shared/enums/userRoles';
import { AuthSessionService } from '../services/auth/auth-session.service';

@Injectable({
  providedIn: 'root'
})
export class ChainsResolver implements Resolve<Chain[]> {

  constructor(
    private router: Router,
    private authSessionService: AuthSessionService
  ) {}
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Chain[]> {
    return this.authSessionService.bootstrap().pipe(
      switchMap((session) => {
        if (!session) {
          this.router.navigate(['login']);
          return NEVER;
        }

        const { user, chains, restaurants } = session;

        if (user.globalRole === UserRoles.superAdmin || chains.length > 1) {
          return of(chains);
        } else if (chains.length === 1) {
          const chainId = chains[0]?.id;
          this.router.navigate(['chains', chainId, 'restaurants']);
          return NEVER; // return an observable that never emits
        } else {
          const restaurantId = restaurants[0]?.id;
          this.router.navigate(['restaurants', restaurantId, 'tables']);
          return NEVER; // return an observable that never emits
        }
      })
    );
  }
}
